module.exports = __webpack_public_path__ + "static/media/shaff1171.8fa9d91f.jpg";